import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter", "input", "warning"]
  static values = {
    used: Number,
    limit: Number
  }

  connect() {
    this.update()
  }

  update() {
    const terms = this.terms
    const count = terms.length
    const remaining = Math.max(this.limitValue - this.usedValue, 0)

    this.counterTarget.textContent = `${count} keyword${count === 1 ? "" : "s"} detected`

    if (count > remaining) {
      this.warningTarget.textContent =
        `Adding ${count} keywords would exceed your limit of ${this.limitValue}. Only ${remaining} will be added.`
      this.warningTarget.classList.remove("d-none")
    } else {
      this.warningTarget.textContent = ""
      this.warningTarget.classList.add("d-none")
    }
  }

  get terms() {
    return this.inputTarget.value
      .split(/[\n,]+/)
      .map((term) => term.trim())
      .filter(Boolean)
  }
}
